import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import SurveyEmailTable from "../../components/user/UserSurveyComponent/SurveyEmailTable";
import { Box, Tab, Tabs, CircularProgress } from '@mui/material';
import { useApiService } from '../../services/ApiService/ApiService';

function UserSurveyPage(props: any) {
    const [activeTab, setActiveTab] = useState(0);
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [emails, setEmails] = useState() as any;
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchEmails = async () => {
        try {
            const response = await fetchWithAuth('/survey/list', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    fleetUuid: userInfo.fleetUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch survey emails');
            }

            const res_json = await response.json();
            setEmails(res_json.successRecords.map((e: any) => ({ 
                ...e, 
                id: e.uuid, 
                sentOnDate: new Date(Date.parse(e.sentOnDate)).toLocaleDateString() 
            })));
        } catch (error) {
            console.error('Error fetching survey emails:', error);
            setIsError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEmails();
    }, [fetchWithAuth, userInfo]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    if (loading) {
        return (
            <Box 
                component="section" 
                sx={{ p: 3 }}
            >
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            </Box>
        );
    }

    return (
        <Box 
            component="section"
            sx={{ p: 3 }}
        >
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={activeTab} 
                        onChange={handleTabChange}
                        aria-label="survey tabs"
                    >
                        <Tab label="All" />
                        <Tab label="Completed" />
                        <Tab label="Requested" />
                    </Tabs>
                </Box>

                <Box>
                    {activeTab === 0 && (
                        <SurveyEmailTable emails={emails} />
                    )}
                    {activeTab === 1 && (
                        <SurveyEmailTable emails={emails.filter((e: any) => e.status === "COMPLETED")} />
                    )}
                    {activeTab === 2 && (
                        <SurveyEmailTable emails={emails.filter((e: any) => e.status === "REQUESTED")} />
                    )}
                </Box>
            </Box>
        </Box>
    );
}

export default UserSurveyPage;
